import React from 'react';
import QuickReplyButtons from './QuickReplyButtons';
import './WelcomeMessage.css';

const WelcomeMessage = ({ onSuggestionClick, isLoading = false }) => {
  const welcomeSuggestions = [
    'I\'m new to yoga',
    'Tell me about your classes',
    'What are the benefits of yoga?',
    'How do I get started?'
  ];

  return (
    <div className="welcome-message-container">
      <div className="welcome-content">
        <div className="welcome-icon">
          {/* Lotus flower */}
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3C11 5.5 11 9 12 11C13 9 13 5.5 12 3Z" fill="currentColor"/>
            <path d="M8.5 5.5C7 8 8 11.5 10.5 13C10.5 10.5 9.5 7.5 8.5 5.5Z" fill="currentColor" opacity="0.85"/>
            <path d="M15.5 5.5C17 8 16 11.5 13.5 13C13.5 10.5 14.5 7.5 15.5 5.5Z" fill="currentColor" opacity="0.85"/>
            <path d="M5.5 8.5C4.5 11 6 14 9 14.5C8.5 12 7 9.5 5.5 8.5Z" fill="currentColor" opacity="0.7"/>
            <path d="M18.5 8.5C19.5 11 18 14 15 14.5C15.5 12 17 9.5 18.5 8.5Z" fill="currentColor" opacity="0.7"/>
            <path d="M7.5 15.5C9 14 10.5 13.5 12 13.5C13.5 13.5 15 14 16.5 15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="12" y1="15.5" x2="12" y2="20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M12 19C10.5 18 9 18 8 19C9 20 10.5 20 12 19Z" fill="currentColor" opacity="0.7"/>
            <path d="M12 19C13.5 18 15 18 16 19C15 20 13.5 20 12 19Z" fill="currentColor" opacity="0.7"/>
          </svg>
        </div>

        <div className="welcome-text">
          <h3>Namaste!</h3>
          <p>Welcome to Yogsadhna Varga yoga studio. I'm here to help you discover the perfect yoga practice for your journey.</p>
          <p className="welcome-subtitle">What brings you to yoga today?</p>
        </div>
      </div>
      
      <div className="welcome-suggestions">
        <QuickReplyButtons
          suggestions={welcomeSuggestions}
          onSuggestionClick={onSuggestionClick}
          disabled={isLoading}
        />
      </div>
      
      <div className="welcome-footer">
        <p>Or feel free to ask me anything about yoga, our classes, or studio!</p>
      </div>
    </div>
  );
};

export default WelcomeMessage;